
import * as Yup from "yup";
export const bgVerificationSchema = Yup.object({
    employeeID: Yup.string().required("Employee ID is required"),
    companyName: Yup.string().required("Company Name is required"),
    location: Yup.string().required("Location is required"),
    lastDesignation: Yup.string().required("Last Designation is required"),
    dateOfJoining: Yup.date().required("Date of Joining is required"),
    department: Yup.string().required("Department is required"),
    remunerationCTC: Yup.number().required("Remuneration (CTC) is required").positive("CTC must be a positive number"),
    reasonsForLeaving: Yup.string().required("Reasons for Leaving are required"),
    natureOfEmployment: Yup.string().required("Nature of Employment is required"),
    anyPerformanceIntegrity: Yup.string().required("Performance/Integrity comments are required"),
    reason: Yup.string().required("Reason is required"),
    exitFormalitiesInput: Yup.string().required("Exit Formalities Input is required"),
    exitFormalitiesCompleted: Yup.string().required("Exit Formalities Completed status is required"),
    eligibleToReHire: Yup.string().required("Eligible to Rehire status is required"),
    verifierDetails: Yup.string().required("Verifier Details are required"),
    verifierName: Yup.string().required("Verifier Name is required"),
    verifierDesignation: Yup.string().required("Verifier Designation is required"),
  });